import React from 'react';
import logo from '../../images/firesideometerLogo.png';
import { NavLink, useLocation } from "react-router-dom";
import './app-header.scss';

export const AppHeader = () => {
	return (
		<div className="app-header">
			<div className="app-header-content">
				<div className="logo"><NavLink exact to="/"><img src={logo} alt="Firesideometer A.D." /></NavLink></div>
			</div>
		</div>
	);
}

export default AppHeader;
